import { createBrowserRouter } from "react-router-dom";
import { buildNumber, currentEnv, googleGAKey, isDevelopment } from "./environment";
import ReactGA from "react-ga4";
import axios from "axios";

export const analyticsSetup = () => {
  if (isDevelopment) return;

  ReactGA.initialize(googleGAKey, {
    gaOptions: {
      allowLinker: true,
      cookieDomain: "auto",
    },
  });
};

export const getCreateRouter = () => {
  return createBrowserRouter;
};

export const getGclid = (): string | null => {
  // First try to get from URL
  const urlParams = new URLSearchParams(window.location.search);
  const gclidFromUrl = urlParams.get("gclid");

  if (gclidFromUrl) {
    return gclidFromUrl;
  }

  // Then try to get from cookie (if GTM Conversion Linker is enabled)
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split("=");

    if (name === "gclid") {
      return value;
    }
  }

  return null;
};
